export default __webpack_public_path__ + "static/pragicts-itops-it-support-707120a33a488fb9cb6d5403bb61c54a.jpg";